let activeBrand = localStorage.getItem("data-brand-id");
switch (activeBrand) {
  case "0f6a24b8-029d-4155-a47f-87f0045e56ca":
    let eminence_header = document.getElementById('header-eminence');
    let eminence_menu = document.getElementById('menu-eminence');
    let eminence_footer = document.getElementById('footer-eminence');
    eminence_header.style.display = 'block';
    eminence_menu.style.display = 'block';
	  eminence_footer.style.display = 'block';
  break;
  case "2c33983b-bfb4-4927-914a-198db1457e29":
    let nutrins_header = document.getElementById('header-nutrins');
    let nutrins_menu = document.getElementById('menu-nutrins');
    let nutrins_footer = document.getElementById('footer-nutrins');
    nutrins_header.style.display = 'block';
    nutrins_menu.style.display = 'block';
    nutrins_footer.style.display = 'block';
  break;
  case "fed0b9b8-bd06-4ed5-8975-a417419b6c4e":
    let aab_header = document.getElementById('header-aab');
    let aab_menu = document.getElementById('menu-aab');
    let aab_footer = document.getElementById('footer-aab');
    aab_header.style.display = 'block';
    aab_menu.style.display = 'block';
    aab_footer.style.display = 'block';
  break;
  case "brand_hnR6fN":
    let labrains_header = document.getElementById('header-labrains');
    let labrains_menu = document.getElementById('menu-labrains');
    let labrains_footer = document.getElementById('footer-labrains');
    labrains_header.style.display = 'block';
    labrains_menu.style.display = 'block';
    labrains_footer.style.display = 'block';
  break;
  default:
    let ap_header = document.getElementById('header-ap');
    let ap_menu = document.getElementById('menu-ap');
    let ap_footer = document.getElementById('footer-ap');
	  ap_header.style.display = 'block';
    ap_menu.style.display = 'block';
    ap_footer.style.display = 'block';
  break;
}

$(document).ready(function() {
  const elem = document.querySelector(`[data-brand-id]`);
  $('.site-navigation').each(function(i, obj) {
    if(obj.dataset.brandId == localStorage.getItem('data-brand-id')) {
      $(this).show();
    }
  });
})
